import { render, staticRenderFns } from "./DonationsComponent.vue?vue&type=template&id=67c59e12&scoped=true&v-if=widgetType%20%3D%3D%3D%20'Donations'&"
import script from "./DonationsComponent.vue?vue&type=script&lang=js&"
export * from "./DonationsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DonationsComponent.vue?vue&type=style&index=0&id=67c59e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c59e12",
  null
  
)

export default component.exports